import { AssetLocationDto } from './asset-location.dto';
import { EpimsBaseEntityDto } from './epim-base.dto';
import { LandParcelDto } from './land-parcel.dto';
import { LandTitleNameDto } from './land-title-name.dto';
import { LandTitleRegisterDto } from './land-title-register.dto';
import { LessorAreaMakerDto } from './lessor-area-marker.dto';
import { LessorInfoDto } from './lessor-info.dto';
import { StorageLocationDto } from './storage-location.dto';

export class LandTitleAuditTrayDto extends EpimsBaseEntityDto {
  LandTitleId: string;
  LandParcelId: string;
  LandName: string;
  AcquisitionDate: Date;
  RecAcquisitioDate: Date;
  TotalArea: number;
  RecTotalArea: number;
  NewLandId: string;
  NewLandName: string;
  SubGroupId: string;
  SubSubGroupId: string;
  MeasureId: string;
  RecTotalCost: number;
  TotalCost: number;
  CurrencyId: string;
  AcquisitionTypeId: string;
  LandUseStatus: string;
  DivestmentStatusId: string;
  RightHeldId: string;
  PurposeId: string;
  TerrainId: string;
  FileLocation: string;
  SubscriptionUserId: string;
  UrlOfDrawing: string;
  CentroidCoordinate: number;
  PobLatitudeDegree: number;
  PobLatitudeMin: number;
  PobLatitudeSec: number;
  PobLongitudeDegree: number;
  PobLongitudeMin: number;
  PobLongitudeSec: number;
  StateId: string;
  LgaId: string;
  CategoryId: string;
  LAcres: number;
  LHectares: number;
  LSqKilometers: number;
  LSqMeters: number;
  LSqFeet: number;
  LRoods: number;
  LPerche: number;
  Verified: string;
  VerificationRemarks: string;
  LongPole: number;
  LatPole: number;
  SurveyDocumentNo: string;
  CurrentExpirationDate: Date;
  DatumId: string;
  Easting: number;
  Northing: number;
  NewNameRemark: string;
  DivisionId: string;
  Breakdown: string;
  LocationId: number;
  SurveyDate: Date;
  AccountableFunctionId: string;
  LandBankingId: string;
  LandLeaseId: string;
  FileLocationId: string;
  UpdatedDate: Date;
  LastUpdatedBy: string;
  CreatePersonId: string;
  ApprovalId: string;
  ApprovalPersonId: string;
  ApprovalDate: Date;
  ApprovalStatus: string;
  CofONumber: string;
  DateGranted: Date;
  CofOStatusId: string;
  Expiration: Date;
  FileNo: string;
  FamilyName: string;
  CommunityId: string;
  NoOfLandlord: string;
  OriginalLandlord: string;
  CurrentLandlord: string;
  RentalPreviousAmount: number;
  RentalMainAmount: number;
  RentalExpirationDate: Date;
  RentalLeaseExpiredDate: Date;
  RentalLastPaymentDate: Date;
  RentalTransactionDescription: string;
  RentalFirstCallDate: Date;
  RentalLastCallDate: Date;
  RentalNextCallDate: Date;
  RentalReminderDays: number;
  RentalReminderEmail: string;
  RentalFirstCallYear: number;
  RentalLastCallYear: number;
  RentalExpirationStatus: string;
  RentalRateId: string;
  GroundRentFirstCallDate: Date;
  GroundRentLastCallDate: Date;
  GroundRentNextCallDate: Date;
  GroundRentFirstCallYear: number;
  GroundRentLastCallYear: number;
  GroundRentDescription: string;
  GroundRentExpiration: Date;
  RentalCurrencyName: string;
  GroundRentCurrencyName: string;
  GroundRentOutstandingAmount: number;
  GroundRentPaidAmount: number;
  RentalOutstandingAmount: number;
  GroundLastPaymentDate: Date;
  GroundRentExpirationStatus: string;
  TenementFirstCallDate: Date;
  TenementLastCallDate: Date;
  TenementNextCallDate: Date;
  TenementFirstCallYear: number;
  TenementLastCallYear: number;
  TenementCompanyAmountPaid: number;
  TenementCompanyAmountOutstanding: number;
  TenementLgaAmountPaid: number;
  TenementLgaAmountOutstanding: number;
  TenementExpirationStatus: string;
  TenementExpirationDate: Date;
  TEnementTransactionDescription: string;
  TenementLastPaymentDate: Date;
  COfOExpirationDate: Date;
  Plot: number;
  EncroachmentStatusId: string;
  EncroachmentStatusName: string;
  EncroachmentDate: Date;
  EncroachmentDesc: string;
  EncroachmentRecommendation: string;
  EncroachmentInformPersonId: string;
  EncroachmentInformPersonName: string;
  EncroachmentHistoryId: string;
  LandEndUseStartDate: Date;
  LandEndUseDescription: string;
  LandEndUseRemarks: string;
  LandEndUseAutoNumber: number;
  LandCode: string;
  GroupId: string;
  LandUseStatusId: string;
  ExpirationDate: Date;
  FileFiscalLocationId: string;
  RentalRate: number;
  FileFiscaLocation_FileLocationId: string;
  FiscalFileLocation_FileLocationId: string;
  LesseeId: string;
  ReferenceNo: string;
  SurveyDrawingNoMap: string;
  OwnershipTypeId: string;
  OwnershipTypeName: string;
  OwnershipStatusName: string;
  LandRemarks: string;
  LandCodeRemarks: string;
  CofODate: Date;
  StateName: string;
  LgaName: string;
  CommunityName: string;
  FiscalFileRemarks: string;
  RackTrayRefId: string;
  CabinetShelfRefId: string;
  BankingStatus_BankingStatusId: string;
  LPlot: number;
  AssetLocationAddress: string;
  VerificationStatusId: string;
  Duration: number;
  LandNameObligationName: string;
  CodeType: string;
  landParcels: LandParcelDto[];
  storageLocations: StorageLocationDto[];
  landTitleRegisters: LandTitleRegisterDto[];
  lessorInfos: LessorInfoDto[]
  lessorAreaMakers: LessorAreaMakerDto[]
  landTitleNames: LandTitleNameDto[]
  assetLocations: AssetLocationDto[]
}
